import { useEffect, useState } from "react";
import styles from './BusinessDivisionDesktop.module.scss';
import { useTranslation } from 'next-i18next';
import { ForwardArrows } from "./ForwardArrows";
import { useRouter } from "next/router";

export const BusinessDivisionItem = ({ journey, hoverstate, setHoverState }) => {
    const { t } = useTranslation();
    const router = useRouter();

    const getImage = (journey) => {
        const directory = `/landings/assets/images/business_division/journey_${hoverstate}_${journey}.png`;
        const result = `${directory}`;
        return result;
    }

    const setHoverOn = () => {
        setHoverState(journey);
    }

    const getArrows = () => {
        let result = journey === 'acceleration' ? '#9FE870' : journey === 'disruption' ? '#0AE1FF' : '#7D72FF';
        if (journey !== hoverstate) {
            result += '75';
        }

        return result;
    }

    const handleClickDivisionDetailsButton = () => {
        router.push(`/${router.query.locale}/business-division/${journey}`);
    }

    return (
        <div className={styles.journey_item}
            onMouseEnter={setHoverOn}
            onClick={handleClickDivisionDetailsButton}>
            <div className={styles.image}>
                <img
                    src={getImage(journey)}
                    alt="Imagem"
                    className={styles[journey]}
                />
            </div>
            <div className={styles.timeline_group + ' ' + (journey !== hoverstate ? styles.timeline_group_disabled : '')}>
                <div className={`${styles.timeline} ${styles[journey]}`} />
                {journey === 'expansion' &&
                    <div className={styles.arrow}>
                        <img src="/landings/assets/images/business_division/arrow.svg" className={hoverstate !== 'default' ? styles.timeline_dot_disabled : ''} />
                    </div>
                }
                <div className={`${styles.timeline_dot} ${styles[journey]} ${journey !== hoverstate ? styles.disabled : ''}`} />
            </div>

            <div className={`${styles.text_arrow}`}>
                <p className={`${styles[journey]} ${(journey !== hoverstate ? styles.timeline_text_disabled : '')}`}>
                    {t(`businessDivision.${journey}`)}
                </p>
                <ForwardArrows
                    fill={getArrows()}
                />
            </div>
        </div>
    );
}